import axios from "axios";
import {ApiResponse} from "@interface/common";
import {
    DashboardDetailSearchConditions,
    SensorDetailItem,
    SensorDetailParam,
    SensorDetailSearchConditions
} from "@interface/dashboard/Dashboard";

export const getSensorDetailSearchConditions = async () => {
    const {data} = await axios.get<ApiResponse<SensorDetailSearchConditions>>('/api/sensor-data/search-conditions');
    return data;
};

export const getSensorDetail = async (param:SensorDetailParam) => {
    const {data} = await axios.get<ApiResponse<SensorDetailItem[]>>('/api/sensor-data/list',{params:param});
    return data;
};